//For Internet Explorer Browser
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
//For Internet Explorer Browser
import React from 'react';
import ReactDOM from 'react-dom';

const rootEl = document.getElementById('app-site');

// Create a reusable render method that we can call more than once
let render = () => {
  //sessionStorage.clear()
  //let resource_group = (sessionStorage.getItem('user'))?JSON.parse(sessionStorage.getItem('user')).TOKEN:{};
  //console.log('RCS ',jwtDecode(JSON.parse(resource_group)));
  //alert(window.location.href.split('app/')[1]+" -- OK")
  // Dynamically import our main App component, and render it
  const MainApp = require('./MainApp').default;
  ReactDOM.render(
    <MainApp />,
    rootEl
  );
};

if (module.hot) {
  module.hot.accept('./MainApp', () => {
    const MainApp = require('./MainApp').default;
    render(
      <MainApp />,
      rootEl
    );
  });
}

render();
